import { bool, cleanEnv, json, num, str } from 'envalid';

// Vite exposes env vars on import.meta.env
// We need to convert string values to proper types
const rawEnv = {
  VITE_TESTNET: import.meta.env.VITE_TESTNET,
  VITE_DEFAULT_CHAIN_ID: import.meta.env.VITE_DEFAULT_CHAIN_ID,
  VITE_PRIVY_APP_ID: import.meta.env.VITE_PRIVY_APP_ID,
  VITE_WALLET_CONNECT_PROJECT_ID: import.meta.env
    .VITE_WALLET_CONNECT_PROJECT_ID,
  VITE_WAGMI_TRANSPORTS: import.meta.env.VITE_WAGMI_TRANSPORTS,
  VITE_API_BASE_URLS: import.meta.env.VITE_API_BASE_URLS,
  VITE_DELEGATE_IDENTITY: import.meta.env.VITE_DELEGATE_IDENTITY,
  VITE_DELEGATE_PERCENTAGE: import.meta.env.VITE_DELEGATE_PERCENTAGE,
  VITE_SHINKAI_WEB_API_URL: import.meta.env.VITE_SHINKAI_WEB_API_URL,
};

export const env = cleanEnv(rawEnv, {
  VITE_TESTNET: bool(),
  VITE_DEFAULT_CHAIN_ID: num(),
  VITE_PRIVY_APP_ID: str(),
  VITE_WALLET_CONNECT_PROJECT_ID: str(),
  VITE_WAGMI_TRANSPORTS: json<Record<string, string>>(),
  VITE_API_BASE_URLS: json<Record<string, string>>(),
  VITE_DELEGATE_IDENTITY: json<Record<string, string>>(),
  VITE_DELEGATE_PERCENTAGE: num(),
  // Empty string for local dev (uses Vite proxy), full URL for production
  VITE_SHINKAI_WEB_API_URL: str({ default: '' }),
});
